import { render } from "./IphoneBar.vue?vue&type=template&id=35bf0eae&scoped=true"
import script from "./IphoneBar.vue?vue&type=script&lang=js"
export * from "./IphoneBar.vue?vue&type=script&lang=js"

import "./IphoneBar.vue?vue&type=style&index=0&id=35bf0eae&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bf0eae"]])

export default __exports__